import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { authAPI } from '../../api';
import Button from '../../components/common/Button';
import Input  from '../../components/common/Input';
import styles from './Auth.module.css';

const RegisterPage = () => {
  const navigate = useNavigate();
  const [form,    setForm]    = useState({ name: '', email: '', password: '', role: 'staff', phone: '' });
  const [errors,  setErrors]  = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name    || form.name.length < 2)    e.name     = 'Name must be at least 2 characters';
    if (!form.email)                               e.email    = 'Email is required';
    if (!form.password|| form.password.length < 6) e.password = 'Password must be at least 6 characters';
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const e2 = validate();
    if (Object.keys(e2).length) return setErrors(e2);
    setLoading(true);
    try {
      await authAPI.register(form);
      toast.success('Account created! Please log in.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.header}>
          <span className={styles.logo}>🚲</span>
          <h1 className={styles.title}>Create account</h1>
          <p className={styles.subtitle}>Join the bike rental platform</p>
        </div>

        <form onSubmit={handleSubmit} className={styles.form} noValidate>
          <Input label="Full name"    type="text"     placeholder="John Doe"           value={form.name}     onChange={set('name')}     error={errors.name} />
          <Input label="Email"        type="email"    placeholder="you@example.com"    value={form.email}    onChange={set('email')}    error={errors.email} />
          <Input label="Password"     type="password" placeholder="Min 6 characters"   value={form.password} onChange={set('password')} error={errors.password} />
          <Input label="Phone"        type="tel"      placeholder="+91-9000000000"     value={form.phone}    onChange={set('phone')} />

          <div className={styles.selectWrap}>
            <label className={styles.selectLabel}>Role</label>
            <select className={styles.select} value={form.role} onChange={set('role')}>
              <option value="staff">Staff</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          <Button type="submit" loading={loading} fullWidth size="lg">Create account</Button>
        </form>

        <p className={styles.footer}>
          Already have an account? <Link to="/login" className={styles.link}>Sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
